import { render, staticRenderFns } from "./ResultMain.vue?vue&type=template&id=3be57bc4&"
import script from "./ResultMain.vue?vue&type=script&lang=js&"
export * from "./ResultMain.vue?vue&type=script&lang=js&"
import style0 from "./ResultMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports